import { Language } from '../i18n/constants';
import { makeAnonymousMutator } from './anonymous-mutator';

export type Options = {
  url: string;
  retrieveAccessToken: () => Promise<string>;
  method: 'GET' | 'POST' | 'PUT' | 'DELETE';
  bodyType?: 'json' | 'raw';
  language: Language;
};

/**
 * This function is used to create a mutator for Tanstack query and should only be used for mutations.
 */
export const makeAuthenticatedMutator =
  <TData, TPayload>({ url, retrieveAccessToken, method, bodyType = 'json', language }: Options) =>
  async (payload: TPayload): Promise<TData> => {
    const accessToken = await retrieveAccessToken();

    const authHeader = {
      Authorization: 'Bearer ' + accessToken,
    };
    const anonymousMutator = makeAnonymousMutator<TData, TPayload>({
      url,
      headers: authHeader,
      method,
      bodyType,
      language,
    });
    return anonymousMutator(payload);
  };
